/*
状态对象
 */
export default {
  user: {},
  host: {},
  site: {},
  alllanguage: {},
  menu: {
    index: '1'
  },
  nav: {
    index: '/backend/user',
    list: [{ menuIndex: '1', name: '站点首页', path: '/backend/user' }]
  },
  // 设计页面
  design: {
    iframeSrc: '',
    ref: null,
    pageId: -1,
    // 刷新页面控制变量
    refresh: 0
  },
  loginDomain: '',
  loginUrl: ''
}



// WEBPACK FOOTER //
// ./src/store/state/index.js